(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tab-silder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cts-tabs')) {
    class CtsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-cts-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-cts-panel]'));

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });

        this.panels.forEach((panel) => this.initPanel(panel));

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i);
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          if (i === index && panel._ctsUpdate) panel._ctsUpdate();
        });
      }

      initPanel(panel) {
        const track = panel.querySelector('[data-cts-track]');
        if (!track) return;
        const bar = panel.querySelector('[data-cts-bar]');
        const thumb = panel.querySelector('[data-cts-thumb]');
        const prev = panel.querySelector('[data-cts-prev]');
        const next = panel.querySelector('[data-cts-next]');

        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          if (bar && thumb) {
            const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
            bar.hidden = max <= 1;
            thumb.style.width = ratio * 100 + '%';
            const pos = max > 0 ? track.scrollLeft / max : 0;
            thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
          }
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        };
        panel._ctsUpdate = update;

        const step = () => {
          const card = track.querySelector('.cts-card');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
        };

        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

        track.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        window.addEventListener('resize', update);

        if (bar && thumb) {
          let dragging = false;
          let snapType = '';
          const seek = (e) => {
            const rect = bar.getBoundingClientRect();
            const tw = thumb.offsetWidth;
            const range = rect.width - tw;
            const x = range > 0 ? (e.clientX - rect.left - tw / 2) / range : 0;
            const max = track.scrollWidth - track.clientWidth;
            track.scrollLeft = Math.max(0, Math.min(1, x)) * max;
          };
          bar.addEventListener('pointerdown', (e) => {
            dragging = true;
            snapType = track.style.scrollSnapType;
            track.style.scrollSnapType = 'none';
            bar.setPointerCapture(e.pointerId);
            seek(e);
          });
          bar.addEventListener('pointermove', (e) => {
            if (dragging) seek(e);
          });
          const stop = () => {
            if (!dragging) return;
            dragging = false;
            track.style.scrollSnapType = snapType;
          };
          bar.addEventListener('pointerup', stop);
          bar.addEventListener('pointercancel', stop);
        }

        update();
      }
    }

    customElements.define('cts-tabs', CtsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('igg-gallery')) {
    class IggGallery extends HTMLElement {
      connectedCallback() {
        const spacer = this.querySelector('.igg__spacer--below');
        if (spacer) {
          const mq = window.matchMedia('(max-width: 749px)');
          const setGap = () => {
            const px = (mq.matches ? spacer.dataset.mobile : spacer.dataset.desktop) + 'px';
            spacer.style.setProperty('height', px, 'important');
            spacer.style.setProperty('min-height', px, 'important');
          };
          setGap();
          if (mq.addEventListener) mq.addEventListener('change', setGap);
          else if (mq.addListener) mq.addListener(setGap);
        }

        const track = this.querySelector('[data-igg-track]');
        if (!track) return;
        const bar = this.querySelector('[data-igg-bar]');
        const thumb = this.querySelector('[data-igg-thumb]');
        const prev = this.querySelector('[data-igg-prev]');
        const next = this.querySelector('[data-igg-next]');

        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          if (bar && thumb) {
            const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
            bar.hidden = max <= 1;
            thumb.style.width = ratio * 100 + '%';
            const pos = max > 0 ? track.scrollLeft / max : 0;
            thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
          }
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        };

        const step = () => {
          const item = track.querySelector('.igg__item');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return item ? item.offsetWidth + gap : track.clientWidth * 0.8;
        };

        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

        track.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        window.addEventListener('resize', update);

        if (bar && thumb) {
          let dragging = false;
          const seek = (e) => {
            const rect = bar.getBoundingClientRect();
            const tw = thumb.offsetWidth;
            const range = rect.width - tw;
            const x = range > 0 ? (e.clientX - rect.left - tw / 2) / range : 0;
            track.scrollLeft = Math.max(0, Math.min(1, x)) * (track.scrollWidth - track.clientWidth);
          };
          bar.addEventListener('pointerdown', (e) => {
            dragging = true;
            track.style.scrollSnapType = 'none';
            bar.setPointerCapture(e.pointerId);
            seek(e);
          });
          bar.addEventListener('pointermove', (e) => {
            if (dragging) seek(e);
          });
          const stop = () => {
            if (!dragging) return;
            dragging = false;
            track.style.scrollSnapType = '';
          };
          bar.addEventListener('pointerup', stop);
          bar.addEventListener('pointercancel', stop);
        }

        this.addEventListener('shopify:block:select', (e) => {
          const item = e.target.closest('.igg__item');
          if (item) track.scrollTo({ left: item.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
        });

        update();
      }
    }

    customElements.define('igg-gallery', IggGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
